<div mat-dialog-content>
	<div class="loading-container">
		<cm-loading-icon></cm-loading-icon>
		<span [cmLocalize]="key" [default]="defaultValue" class="mt-16"></span>
	</div>
</div>
